import { Link } from '@tanstack/react-router'

import { useSupportTicket } from '@/modules/support'
import { useDialogActions } from '@/stores'
import { NEW_CASE_DIALOG_ID } from './NewCaseDialog'

const actionClass =
  'cursor-pointer font-medium text-foreground underline underline-offset-2 hover:text-foreground/70'

export const NeedMore = ({ limit }: { limit: 'allowance' | 'pageCap' }) => {
  const { openScreeningAllowanceTicket } = useSupportTicket()
  const { openDialog } = useDialogActions()

  return (
    <span className="text-muted-foreground text-sm">
      Need more?{' '}
      {limit === 'allowance' ? (
        <>
          <Link
            to="/credits"
            hash="screenings-wallet-heading"
            className={actionClass}
          >
            Buy screening credits
          </Link>{' '}
          or{' '}
          <button
            type="button"
            onClick={openScreeningAllowanceTicket}
            className={actionClass}
          >
            request more
          </button>
          .
        </>
      ) : (
        <>
          <button
            type="button"
            onClick={() => openDialog(NEW_CASE_DIALOG_ID)}
            className={actionClass}
          >
            Split the case
          </button>{' '}
          and screen each half.
        </>
      )}
    </span>
  )
}
